import React, { createContext, useContext, useState, useRef, useEffect } from "react"
import useAppStore from "./useAppStore"

interface ILocationProp {
  mode:"builder"|"render"|"build"|"preview"
  state?: {
    template:"list"|"selected"|undefined
    element:"list"|"selected"|undefined
    statement:"list"|"selected"|undefined
  }
}

interface IDefaultState {
  randomizers: {
    statements:string|null
  },
  statementLoadParams: { parent: string, level: number, parentResult: string, randomizer: "" }|null,
  user:any
  // sidebar:string,
  // mask:string,
  ui: { 
    mask:boolean,
    feedback:any,
    help:any,
    modal: {
      target:string|null
      open:boolean
      config:any
    },
    sidebar: {
      expanded:boolean
    },
    toast:{
      id: Date|null,
      visible:boolean
      message:string
      type?:"info"|"warning"|"error"|"success"|"confirm"
      showCloseBtn?:boolean
      waitFor?:number
      onConfirm?:()=>void
      onDeny?:()=>void
    }
   },
  location:ILocationProp 
  viewmode:string,
  confirms:any,
  metas: {
    contentAutoSave:string|null
    conditionalSpotlight:any
    conditionalModal:any
    conditionalTest:any
    docsvisible:boolean
    currentContentAction:string
    contentActions:any
    createTemplateModal:boolean,
    conditionalTargetZoneIdx:number,
    conditionalToLoad:any
    statementLoaderExpanded:boolean
    statementToLoad:any
    statementModalIsOpen:boolean
  },
  actives: {
    statement:any
    apidata:any 
    client:any
    buildtab:string
  },
  collections: {
    statement:any[]|null
    apidata:any[]|null
  },
  preview: {
    display:"preview"|"pdf"
    reports?:boolean 
    editors?:boolean,
    editing?:any
    measurements?: {
      supportingImagesContainer:number
    }
  },
  template:any
  element:any
  config:any
  presets: {
    visible:boolean
    active:any
    ready?:boolean
    collection:any[]|null
  },
  developer: {
    visible:boolean
  }
}

const defaultState:IDefaultState = {
  randomizers: {
    statements: null
  },
  user: null,
  statementLoadParams: null,
  // sidebar: 'expanded',
  // mask: 'hidden',
  ui: {
    feedback: { open: false },
    help: { open: false },
    modal: { target: null, open: false, config: null },
    mask: false,
    sidebar: { expanded: true },
    toast: {
      id: null,
      visible: false,
      message: "",
      type: "info",
      showCloseBtn: false,
      waitFor: 5000,
      onConfirm: () => null,
      onDeny: () => null
     }
  },
  location: {
    mode: "builder"
  },
  viewmode: "build",
  confirms: {},
  metas: {
    contentAutoSave: null,
    conditionalSpotlight: null,
    conditionalModal: null,
    conditionalTest: null,
    docsvisible: false,
    currentContentAction: "pass",
    contentActions: {},
    createTemplateModal: false,
    conditionalTargetZoneIdx: 0,
    conditionalToLoad: null,
    statementLoaderExpanded: true,
    statementToLoad: null,
    statementModalIsOpen: false
  },
  actives: {
    statement: { conditional: null },
    apidata: null,
    client: null,
    buildtab: "Build"
  },
  collections: {
    statement: null,
    apidata: null
  },
  preview: {
    display: "preview",
    reports: false,
    editors: false,
    editing: null,
    measurements: {
      supportingImagesContainer: 0
    }
  },
  template: null,
  element: {
    refstr: null,
    title: null,
    config: null
  },  
  config: null,
  presets: {
    visible: true,
    active: null,
    ready: false,
    collection: null
  },
  developer: {
    visible: false
  }
}

const AppStoreContext = createContext<any>({});
export const appStore = () => useContext(AppStoreContext);


export default function AppStoreProvider({ children }: { children: any }){

  const refs = useRef({ 
    // content: { pass: "", fail: "" },
    statements: {}
  })

  const [ store, setStore ] = useState<IDefaultState>(defaultState)
  const AppStore = useAppStore(store, setStore, refs)

  return (
    <AppStoreContext.Provider value={{ store, AppStore, refs }}>
      {children}
    </AppStoreContext.Provider>
  )

}
